import { createContext } from 'react';

import type { UserDetail } from '~/modules/settings/api/lib/schemas';

export const UserDetailContext = createContext<UserDetail | null>(null);

UserDetailContext.displayName = 'UserDetailContext';
